<template>
  <div>
    <align class="header" flex>
      <h3 class="secondary-font">
        Daily Sales Recap
      </h3>

      <icon-link as="router-link" :to="{ query: { postId: data.mostRecentSalesRecapPostId } }">
        View Recap
      </icon-link>
    </align>

    <div class="grid">
      <stat-item
        size="xlarge"
        success
        label="Total Sales Added"
        :value="$filters.number(data.salesAdded)"
      />

      <stat-item
        size="xlarge"
        success
        label="Total Sales Verified"
        :value="$filters.number(data.dailySalesCount)"
      />

      <stat-item
        size="xlarge"
        success
        label="Sales Verified Amount"
        :value="$filters.currency(data.dailySales)"
      />

      <stat-item
        size="xlarge"
        success
        label="CL Value Accuracy"
        :value="$filters.percentage(data.guideValueAccuracy)"
      />
    </div>
  </div>
</template>

<script>
import StatItem from '@cardladder/shared/components/StatItem';

export default {
  components: {
    StatItem,
  },

  props: {
    data: Object,
  },
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-gap: $gp;
  grid-template-columns: repeat(4, 1fr);

  @media($large-down) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.header {
  margin: 0 0 $gp;
}

h3 {
  margin: 0;
}
</style>
